import React from "react";

import ReactPanZoom from "react-image-pan-zoom-rotate";

import { useTranslation } from "react-i18next";

import "./style.scss";
import EllipsisText from "react-ellipsis-text/lib/components/EllipsisText";

const DocViwer = ({ activeAttachment }) => {
  const { t } = useTranslation();
  const { created_at } = activeAttachment || {};
  const createdAt = created_at && new Date(created_at).toLocaleDateString();

  if (!activeAttachment?.files) {
    return (
      <div className="empty-state">
        <span>{t("Select a file for analysis")}</span>
      </div>
    );
  }

  if (!activeAttachment?.files?.file_url) {
    return (
      <div className="empty-file">
        <p className="note">{t("No document to view")}</p>
        <div className="infos-page">
          {activeAttachment?.file_status === "requested" ? (
            <>
              <p>
                <strong>{t("File name")}: </strong>
                <EllipsisText
                  text={`${activeAttachment?.files?.file_name}`}
                  length={"50"}
                />
              </p>
            </>
          ) : (
            <>
              <p>
                <strong>{t("File name")}: </strong>
                <EllipsisText
                  text={`${activeAttachment?.note}`}
                  length={"50"}
                />
              </p>
            </>
          )}

          <p>
            <strong>{t("Date")}: </strong>
            {createdAt || "--/--/---"}
          </p>
          <p>
            <strong>{t("Reason")}: </strong>
            <EllipsisText text={`${activeAttachment?.reason}`} length={"50"} />
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {activeAttachment?.files?.mime_type === "application/pdf" ? (
        <iframe
          title={activeAttachment?.files?.file_name}
          src={activeAttachment?.files?.file_url}
          frameborder="0"
          width="100%"
          height="100%"
        />
      ) : (
        <div className="container-image">
          <ReactPanZoom
            alt={activeAttachment?.files?.file_name}
            image={activeAttachment?.files?.file_url}
          />
        </div>
      )}
    </>
  );
};

export default DocViwer;
